<div class="text-white px-5 pt-3 pb-5 d-flex justify-content-center d-none d-lg-block">
    <table class="coverage-table w-100">
        <tr>
            <td>COVERAGE ALL THE WAY THROUGH*</td>
            <td>TREDDER</td>
            <td>BIG INSURANCE</td>
        </tr>
        <tr>
            <td>COVERAGE OFF-ROAD</td>
            <td>✅</td>
            <td>❌ nope</td>
        </tr>
        <tr>
            <td>TOTAL REPLACEMENT VALUE (INCLUDES YOUR MODS)</td>
            <td>✅</td>
            <td>❌ mods?</td>
        </tr>
        <tr>
            <td>SPECIALTY MAINTENANCE & REPAIR COVERAGE</td>
            <td>✅</td>
            <td>❌ lol. no.</td>
        </tr>
        <tr>
            <td>OFF-ROAD RECOVERY & ASSISTANCE</td>
            <td>✅</td>
            <td>❌ you kidding me?</td>
        </tr>
        <tr>
            <td>CAMPSITE COVERAGE</td>
            <td>✅</td>
            <td>❌ what?</td>
        </tr>
        <tr>
            <td>OFF-ROAD DRIVER TRAINING DISCOUNT</td>
            <td>✅</td>
            <td>❌ nah</td>
        </tr>
        <tr>
            <td>STOWAGE / SEASONAL COVERAGE</td>
            <td>✅</td>
            <td>❌ yah right</td>
        </tr>
        <tr>
            <td>OFF-ROAD COVERAGE CUSTOMIZATION</td>
            <td>✅</td>
            <td>❌ never</td>
        </tr>
    </table>
</div>
<div class="text-white px-3 pt-3 pb-5 d-flex justify-content-center d-block d-lg-none">
    <table class="coverage-table w-100">
        <tr>
            <td>
                <div class="d-inline-block">TREDDER COVERAGE</div>
                <div class="d-inline-block">ALL THE WAY THROUGH*</div>
            </td>
            <td>BIG INSURANCE</td>
        </tr>
        <tr>
            <td>✅ COVERAGE OFF-ROAD</td>
            <td>❌ nope</td>
        </tr>
        <tr>
            <td>✅ TOTAL REPLACEMENT VALUE (+MODS)</td>
            <td>❌ mods?</td>
        </tr>
        <tr>
            <td>✅ SPECIALTY MAINTENANCE & REPAIR</td>
            <td>❌ lol. no.</td>
        </tr>
        <tr>
            <td>✅ OFF-ROAD RECOVERY & ASSISTANCE</td>
            <td>❌ kidding?</td>
        </tr>
        <tr>
            <td>✅ CAMPSITE COVERAGE</td>
            <td>❌ what?</td>
        </tr>
        <tr>
            <td>✅ AFFINITY DISCOUNTS</td>
            <td>❌ nah</td>
        </tr>
        <tr>
            <td>✅ STOWAGE / SEASONAL COVERAGE</td>
            <td>❌ yah right</td>
        </tr>
        <tr>
            <td>✅ COVERAGE CUSTOMIZATION</td>
            <td>❌ never</td>
        </tr>
    </table>
</div>
